import updateDesign from './updateDesign';
import {
  selectToeKickSuperSkuId,
  selectProductsModalType,
  selectDesignById,
  selectProductsModalTypeByParentId
} from '../selectors';
import { updateCartWithToekicks } from '../../../utils/toekickCalculator';
import { getProductParentIdEntry } from './utils';

export default async (set, get, host, designId, updatedProducts,
  addedProductInfo, metadataBaseUrl, cabinetDirection) => {
  try {
    const stateCabinetVisualizer = get().cabinetVisualizer;
    const design = selectDesignById(stateCabinetVisualizer, designId);
    const { choices, styleChoiceId: currentStyleChoiceId } = stateCabinetVisualizer;

    // Get toekick SuperSKU for this specific design's style
    // For manual additions, prefer the design's DesignStyleChoiceid,
    // but fallback to current styleChoiceId if design's is not set
    const designStyleChoiceId = design.DesignStyleChoiceid || currentStyleChoiceId;
    const toeKickSuperSkuId = Number(
      selectToeKickSuperSkuId({ choices, styleChoiceId: designStyleChoiceId })
    );

    const newProductType = addedProductInfo?.newProductType
    || selectProductsModalTypeByParentId(stateCabinetVisualizer, addedProductInfo?.parentId, designId);

    // Create getProductType function scoped to this design
    const getProductType = (sku) => selectProductsModalType(
      stateCabinetVisualizer,
      sku,
      designId
    );

    // Update cart with toekicks using standalone module
    const toekickResult = await updateCartWithToekicks({
      products: updatedProducts,
      cart: design.Cart,
      productParentIds: design.ProductParentIds,
      toeKickSuperSkuId,
      toeKickMetadata: stateCabinetVisualizer.toeKickMetadata,
      addedProductInfo: {
        ...addedProductInfo,
        newProductType
      },
      getProductType,
      host,
      collectionId: design.CollectionId
    });

    const updatedDesign = {
      Products: updatedProducts,
      Cart: toekickResult.cart,
      ProductParentIds: {
        ...toekickResult.productParentIds,
        ...getProductParentIdEntry(addedProductInfo?.itemId, addedProductInfo?.parentId)
      }
    };

    // Add anchorSide to updatedDesign if it exists
    if (cabinetDirection) {
      updatedDesign.AnchorSide = cabinetDirection;
    }

    set(
      updateDesign(set, get, host, designId, updatedDesign),
      false,
      { type: 'cabinetVisualizer/updateDesignProducts' }
    );
  } catch (err) {
    console.error(`Update Cabinet Design Error: ${err}`);
  }
};
